import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { FaroRoutes } from '@grafana/faro-react';

export function initTelemetry() {
  if (typeof window === 'undefined') return;

  const faroUrl = import.meta.env.VITE_FARO_URL || '/api/collect';

  try {
    initializeFaro({
      url: faroUrl,
      app: {
        name: 'caio-frontend',
        version: '1.0.0',
        environment: import.meta.env.MODE || 'development',
      },
      instrumentations: [
        ...getWebInstrumentations(),
      ],
    });
  } catch (err) {
    console.warn('Faro telemetry initialization skipped:', err);
  }
}
